import React from "react";
import type { BeforeAfterItemInterface } from "astro-types/components-interfaces";

import { ImgComparisonSlider } from "@img-comparison-slider/react";

import "./BeforeAfterItem.css";

interface Props extends BeforeAfterItemInterface {}

const BeforeAfterItem: React.FC<Props> = ({
  altText,
  beforeImage,
  afterImage,
  label,
  isDark,
}) => {
  return (
    <article className="article" data-theme={isDark ? "dark" : "light"}>
      <ImgComparisonSlider className="slider">
        <img
          alt={altText || "Before image"}
          slot="first"
          className="image first"
          src={typeof beforeImage === 'string' ? beforeImage : beforeImage.src}
        />
        <img
          alt={altText || "After image"}
          slot="second"
          className="image second"
          src={typeof afterImage === 'string' ? afterImage : afterImage.src}
        />
      </ImgComparisonSlider>
      {label && <p className="cardTitle">{label}</p>}
    </article>
  );
};

export default BeforeAfterItem;
